import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as PermisoService from '../../axios_services/permisosalida.service';

const ModalRechazarPermiso = ({ isOpen, onClose, permiso, tipo, onRefresh }) => {
    const [observaciones, setObservaciones] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen) setObservaciones('');
    }, [isOpen, permiso?.permiso_id]);

    const handleRechazar = async () => {
        if (!observaciones.trim()) {
            alert('Ingrese el motivo del rechazo.');
            return;
        }
        if (!window.confirm('¿Confirma el rechazo de este permiso?')) return;
        setSaving(true);
        try {
            if (tipo === 'rechazar_jefe') {
                await PermisoService.rechazarJefe({ permiso_id: permiso.permiso_id, observaciones });
            } else {
                await PermisoService.rechazarTH({ permiso_id: permiso.permiso_id, observaciones });
            }
            onRefresh();
            onClose();
        } catch (err) {
            alert(err.response?.data?.error || 'Error al rechazar.');
        } finally {
            setSaving(false);
        }
    };

    if (!permiso) return null;

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>RECHAZAR PERMISO</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={e => e.preventDefault()}>

                        <FormGroup>
                            <Label>Colaborador:</Label>
                            <Input
                                type="text"
                                value={permiso.nombre_empleado || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha de Salida:</Label>
                            <Input
                                type="text"
                                value={permiso.fecha_salida || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Motivo de rechazo: *</Label>
                            <Input
                                type="textarea"
                                rows={3}
                                value={observaciones}
                                onChange={e => setObservaciones(e.target.value)}
                                placeholder="Ingrese el motivo del rechazo..."
                            />
                        </FormGroup>

                        <FormGroup style={{ marginTop: '18px', gridColumn: '1 / -1' }}>
                            <div className="button-container">
                                <Button className="button-custom" onClick={handleRechazar} disabled={saving}>
                                    {saving ? 'REGISTRANDO...' : 'REGISTRAR'}
                                </Button>
                            </div>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalRechazarPermiso;
